import download from 'downloadjs'

function downloader (data: Blob, filename: string) {
  download(data, filename)
}

export default {
  download (data: Blob, filename: string) {
    return downloader(data, filename)
  },

  licensePlate (data: Blob) {
    return downloader(data, 'licensePlate.csv')
  },

  packTraces (data: Blob) {
    return downloader(data, 'packTraces.csv')
  },

  inventories (data: Blob) {
    return downloader(data, 'inventories.csv')
  }
}
